import constants from '../constants';
import converters from '../converters';
import LCHColor from '../classes/lch-color';
import minMax from './min-max';
import findClosestGoldenPalette from './find-closest-golden-palette';
import mapPaletteArrayToObject from './map-palette-array-to-object';

const { GOLDEN_PALETTES, TOLERANCE } = constants;
const generatePalette = (
  sourceRgbColor,
  goldenPalettes = GOLDEN_PALETTES.ACCENT,
  lightnessTolerance = TOLERANCE.DEFAULT_LIGHTNESS,
  chromaTolerance = TOLERANCE.DEFAULT_CHROMA
) => {
  const { lch2lab, lab2xyz, xyz2rgb, lab2lch, hex2rgb, xyz2lab, rgb2xyz, rgb2hsl } = converters;
  const sourceLabColor = xyz2lab(rgb2xyz(sourceRgbColor));
  const paletteInLab = goldenPalettes.map((palette) =>
    palette.map((color) => xyz2lab(rgb2xyz(hex2rgb(color))))
  );
  const goldenPalette = findClosestGoldenPalette(sourceLabColor, paletteInLab);
  const goldenColors = goldenPalette.colors;
  const closestGoldenLabColor = goldenColors[goldenPalette.closestReference];
  const closestGoldenLchColor = lab2lch(closestGoldenLabColor);
  const sourceLchColor = lab2lch(sourceLabColor);
  const isGoldenColorGreyInMiddle = lab2lch(goldenColors[5]).chroma < 30;
  const deltaGoldenLightness = closestGoldenLchColor.lightness - sourceLchColor.lightness;
  const deltaGoldenChroma = closestGoldenLchColor.chroma - sourceLchColor.chroma;
  const deltaGoldenHue = closestGoldenLchColor.hue - sourceLchColor.hue;
  let lightnessMaximum = 100;
  const lightnessMinimumStep = 2;

  return mapPaletteArrayToObject(
    goldenColors.map((goldenLabColor, index) => {
      if (goldenLabColor === closestGoldenLabColor) {
        lightnessMaximum = Math.max(sourceLchColor.lightness - 1.7, 0);
        return rgb2hsl(sourceRgbColor);
      }

      const goldenLchColor = lab2lch(goldenLabColor);

      let lightness =
        goldenLabColor.lightness -
        (lightnessTolerance[index] / lightnessTolerance[goldenPalette.closestReference]) *
          deltaGoldenLightness;
      lightness = Math.min(lightness, lightnessMaximum);
      lightness = minMax(lightness, 0, 100);

      let chroma = goldenLchColor.chroma - deltaGoldenChroma;

      if (!isGoldenColorGreyInMiddle) {
        chroma =
          goldenLchColor.chroma -
          deltaGoldenChroma *
            Math.min(
              chromaTolerance[index] / chromaTolerance[goldenPalette.closestReference],
              1.25
            );
      }

      chroma = Math.max(0, chroma);

      const hue = (goldenLchColor.hue - deltaGoldenHue + 360) % 360;

      const lchColor = new LCHColor(lightness, chroma, hue);

      lightnessMaximum = Math.max(lchColor.lightness - lightnessMinimumStep, 0);

      return rgb2hsl(xyz2rgb(lab2xyz(lch2lab(lchColor))));
    })
  );
};

export default generatePalette;
